module.exports = __webpack_public_path__ + "img/fire.62352316.png";